<ng-template #buttonContent>
  <ng-content />
</ng-template>

@switch (type()) {
  @case ('main') {
    @if (full()) {
      <button
        idsMainButton
        full
        [variant]="variant()"
        [attr.id]="btnId() || null"
        [attr.tabindex]="tabindex() || null"
        [disabled]="disabled()"
        [contrast]="contrast()"
        type="button"
        (click)="handleClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent" />
      </button>
    } 
    @else {
      <button
        idsMainButton
        [variant]="variant()"
        [attr.id]="btnId() || null"
        [attr.tabindex]="tabindex() || null"
        [disabled]="disabled()"
        [contrast]="contrast()"
        type="button"
        (click)="handleClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent" />
      </button>
    }
  }
  @case ('directional'){
    <button
      idsDirectionalButton
      [variant]="variant()"
      [attr.id]="btnId() || null"
      [attr.tabindex]="tabindex() || null"
      [disabled]="disabled()"
      type="button"
      [contrast]="contrast()"
      (click)="handleClick($event)"
    >
      <ng-container [ngTemplateOutlet]="buttonContent" />
    </button>
  }
  @case ('contextual'){
    <button
      idsContextualButton
      [variant]="variant()"
      [attr.id]="btnId() || null"
      [attr.tabindex]="tabindex() || null"
      [disabled]="disabled()"
      [contrast]="contrast()"
      type="button"
      (click)="handleClick($event)"
    >
      <ng-container [ngTemplateOutlet]="buttonContent" />
    </button>
  }
  @case ('action'){
    <button
      idsActionButton
      [variant]="variant()"
      [attr.id]="btnId() || null"
      [attr.tabindex]="tabindex() || null"
      [disabled]="disabled()"
      type="button"
      [contrast]="contrast()"
      (click)="handleClick($event)"
    >
      <ids-icon>{{icon()}}</ids-icon>
      <ng-container [ngTemplateOutlet]="buttonContent" />
    </button>
  }
  @default {
    <button
      [attr.id]="btnId() || null"
      [attr.tabindex]="tabindex() || null"
      [disabled]="disabled()"
      type="button"
      [contrast]="contrast()"
      (click)="handleClick($event)"
    >
      <ng-container [ngTemplateOutlet]="buttonContent" />
    </button>
  }
}
